import {
  Button,
  CondensedButton,
  Flex,
  IconUploadLine,
  Text,
  Tooltip,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import CLOUploadModal from "./UploadModals/CLOUploadModal";
import { sortCourses } from "./utils";

const OfferingHeader = ({ course, offering, subject }) => {
  const { t } = useTranslation();
  const [uploadDialog, setUploadDialog] = useState(false);
  const [showOfferings, setShowOfferings] = useState(false);
  const [sharedOfferings, setSharedOfferings] = useState([]);

  // Display offerings that share learning outcomes with the default offering
  useEffect(() => {
    if (offering.is_default) {
      setSharedOfferings(
        sortCourses(
          course.offerings.filter((o) => !o.is_default && !o.has_unique_los)
        )
      );
    }
  }, [course, offering]);

  return (
    <Flex gap="small">
      <Flex.Item shouldShrink>
        <Text wrap="break-word">
          {`${offering.code}: ${offering.course_summary.representative_section_name}`}
        </Text>
      </Flex.Item>
      {sharedOfferings.length > 0 && (
        <Flex.Item shouldShrink>
          <Tooltip
            color="primary-inverse"
            renderTip={
              <View>
                {sharedOfferings.map((offering) => (
                  <Text as="div" key={offering.id}>
                    {offering.code}
                  </Text>
                ))}
              </View>
            }
            isShowingContent={showOfferings}
            placement="end"
          >
            <CondensedButton
              onClick={() => setShowOfferings((prevState) => !prevState)}
            >
              {`${t("analyze.showSharedOutcomes")} ${offering.code}`}
            </CondensedButton>
          </Tooltip>
        </Flex.Item>
      )}
      <Flex.Item shouldGrow textAlign="end">
        <Button
          color="primary"
          size="small"
          renderIcon={IconUploadLine}
          onClick={() => setUploadDialog(true)}
        >
          {t("review.uploadOutcomes")}
        </Button>
      </Flex.Item>
      <CLOUploadModal
        course={course}
        offering={offering}
        uploadDialog={uploadDialog}
        setUploadDialog={setUploadDialog}
        subject={subject}
      />
    </Flex>
  );
};

export default OfferingHeader;
